import { createStore } from 'vuex'

import childEdition from '@/store/modules/childEdition'

export default createStore({
  modules: {
    childEdition
  }
})
